export default "__VITE_ASSET__C5wcjLmU__"